import { client as carol } from '@gecko-akh/carol'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'
import App from './components/App.vue'
import AppWrapper from './components/AppWrapper.vue'
import { handleError } from './general/errorHandling'

const app = createApp(AppWrapper)

const routes = [
  {
    name: 'reisesuche',
    path: '/reisesuche',
    component: App,
  },
  { path: '/', redirect: { name: 'reisesuche' } },
]

const pinia = createPinia()
const router = createRouter({
  routes,
  history: createWebHistory(),
})

pinia.use(({ store }) => {
  store.router = router
})

window.$store = pinia
window.$router = router

app.use(pinia)
app.use(router)

export default (async () => {
  const i18n = createI18n({
    locale: 'de',
    messages: (await carol.i18n()).messages,
  })

  app.use(i18n)
  window.$i18n = i18n

  app.mount('#appWrapper')
})()

// ########################################
// #            Error-Logging             #
// ########################################

window.onerror = async (_msg, _src, _linenum, _colnum, error) => {
  handleError({ error, origin: 'window.onerror' })
}

window.onunhandledrejection = async (error) => {
  handleError({ error: error.reason, origin: 'window.onunhandledrejection' })
}
